// The canonical RainSee login page lives in the yujianadmin H5 application.
import { mutations } from '@/store';
import { showToast } from '@/utils/toast';

export const RAINSEE_LOGIN_URL = 'https://admin.yujianpay.com/h5/pages/login/login';

export function redirectToRainseeLogin(redirectUrl) {
  if (typeof window === 'undefined') return;

  // RainSee clients expose the authenticated account through the yujianObj bridge.
  // Keep using it when available instead of sending the user through H5 login.
  const yujianBridge = window.yujianObj || window.yujianobj;
  if (yujianBridge && typeof yujianBridge.getLoginKey === 'function') {
    try {
      const loginKey = yujianBridge.getLoginKey();
      if (loginKey) {
        mutations.setToken(loginKey);
        showToast('已成功使用当前浏览器雨见账号登录', 'success');
        return;
      }
    } catch (error) {
      console.warn('Could not read login key from yujianObj:', error);
    }
  }

  const browserBridge = window.rainseeBrowser;
  if (browserBridge && typeof browserBridge.openLogin === 'function') {
    browserBridge.openLogin();
    return;
  }

  const target = redirectUrl || window.location.href;
  const loginUrl = new URL(RAINSEE_LOGIN_URL);
  loginUrl.searchParams.set('redirect', target);
  window.location.assign(loginUrl.toString());
}
